export const ar = {
  "NAVIGATION": {
    "HOME": "الرئيسية",
    "PORTFOLIO": "المحفظة",
    "PROFILE": "الملف الشخصي"
  },
  "HOME_SCREEN": {
    "SEARCH": {
      "PLACEHOLDER": "البحث في الصفقات المتاحة",
      "TITLE": "البحث في قسم الصفقات المتاحة فقط"
    },
    "QUICK_FILTERS": {
      "TITLE": "التصفية السريعة",
      "CAPTION": "اختر الفئة",
      "DEFI": "التمويل اللامركزي",
      "STAKING": "التخزين",
      "FARMING": "الزراعة",
      "LENDING": "الإقراض",
      "MINING": "التعدين",
      "TRADING": "التداول",
      "ALL": "الكل",
      "STABLECOINS": "العملات المستقرة",
      "DEPOSITS": "الودائع",
      "DEXES": "منصات التبادل اللامركزية"
    },
    "PREMIUM_DEALS": {
      "TITLE": "الصفقات المميزة",
      "CAPTION": "أفضل صفقات الأسبوع",
      "NO_DEALS": "لا توجد صفقات",
      "NO_DEALS_AVAILABLE": "لا توجد صفقات متاحة",
      "GET_PREMIUM": "احصل على العضوية المميزة",
      "APY": "العائد السنوي",
      "NETWORK": "الشبكة",
      "TOKEN_TYPE": "نوع العملة"
    },
    "FILTERS": {
      "TITLE": "التصفية",
      "FILTERS": "المرشحات",
      "SELECT_FILTERS": "اختر المرشحات",
      "APPLY": "تطبيق"
    },
    "AVAILABLE_DEALS": {
      "TITLE": "الصفقات المتاحة",
      "CAPTION": "فرص السوق الجديدة",
      "NO_DEALS": "لم يتم العثور على فرص"
    }
  },
  "PROFILE_SCREEN": {
    "SUBSCRIPTION_STATUS": {
      "TITLE": "حالة الاشتراك",
      "CAPTION": "تفاصيل عضويتك المميزة",
      "ACTIVE": "نشط",
      "INACTIVE": "غير نشط",
      "PERIOD": "المدة",
      "EXPIRES": "ينتهي في",
      "PROGRESS": "تقدم الاشتراك",
      "NOT_STARTED": "لم يبدأ"
    },
    "REFERRAL": {
      "TITLE": "برنامج الإحالة",
      "CAPTION": "ادعُ أصدقاءك واكسب النقاط",
      "RANK": "المرتبة",
      "TOTAL_REFERRALS": "إجمالي الإحالات",
      "ACTIVE_REFERRALS": "الإحالات النشطة",
      "REFERRALS_BY_LEVEL": "الإحالات حسب المستوى",
      "COPY": "نسخ",
      "POINTS_TO_NEXT_RANK": "{{points}} نقطة للمرتبة التالية"
    },
    "PREMIUM": {
      "TITLE": "الاشتراك المميز",
      "CAPTION": "اختر خطة واحصل على ميزات العضوية المميزة",
      "MONTHS": "أشهر",
      "BEST_VALUE": "أفضل قيمة",
      "PAYMENT_METHOD": "طريقة الدفع",
      "TELEGRAM_STARS": "نجوم تيليجرام",
      "CRYPTO": "العملات المشفرة",
      "YOU_SAVE": "توفيرك",
      "PROCESSING": "جارٍ المعالجة...",
      "PAY_STARS": "ادفع {{amount}} نجمة",
      "PAY_CRYPTO": "ادفع ${{amount}} بالعملات المشفرة",
      "PAYMENT_SUCCESS": {
        "TITLE": "تم الدفع بنجاح",
        "MESSAGE": "تم تفعيل اشتراكك بنجاح!"
      },
      "PAYMENT_ERROR": {
        "TITLE": "خطأ في الدفع",
        "MESSAGE": "فشل معالجة الدفع. يرجى المحاولة مرة أخرى.",
        "STARS_INSUFFICIENT": "نجوم غير كافية للدفع. يرجى إعادة شحن رصيد النجوم عبر @PremiumBot."
      },
      "PAYMENT_CANCELLED": {
        "TITLE": "تم إلغاء الدفع",
        "MESSAGE": "لقد ألغيت الدفع. حاول مرة أخرى عندما تكون مستعدًا."
      },
      "PAYMENT_PENDING": {
        "TITLE": "معالجة الدفع",
        "MESSAGE": "جارٍ معالجة دفعتك. يرجى الانتظار."
      },
      "BUTTONS": {
        "OK": "موافق",
        "CANCEL": "إلغاء",
        "BUY_STARS": "شراء النجوم"
      }
    },
    "FEATURES": {
      "EARLY_ACCESS": "وصول مبكر إلى الصفقات المميزة ذات العائد السنوي المرتفع",
      "EXCLUSIVE_DEFI": "فرص حصرية في التمويل اللامركزي بعائد سنوي يصل إلى 80%",
      "NOTIFICATIONS": "إشعارات فورية للصفقات المميزة الجديدة",
      "GUIDES": "أدلة واستراتيجيات مفصلة خطوة بخطوة",
      "INSIGHTS": "تحليلات وتوصيات أسبوعية للسوق"
    },
    "FOOTER": {
      "CONTACT": "إذا كان لديك أي أسئلة، تواصل معنا على:",
      "EMAIL_COPIED": "تم نسخ عنوان البريد الإلكتروني إلى الحافظة",
      "SUPPORT_TITLE": "الدعم",
      "SUPPORT_CAPTION": "اتصل بنا إذا كان لديك أي أسئلة",
      "EMAIL": "البريد الإلكتروني",
      "TELEGRAM": "تيليجرام"
    },
    "LANGUAGE": {
      "TITLE": "إعدادات اللغة",
      "CAPTION": "اختر لغتك المفضلة",
      "LANGUAGES": {
        "EN": "الإنجليزية",
        "RU": "الروسية",
        "UK": "الأوكرانية",
        "ES": "الإسبانية",
        "AR": "العربية",
        "ZH": "الصينية"
      }
    }
  },
  "PORTFOLIO_STRATEGY_SCREEN": {
    "TITLE": "استراتيجية المحفظة",
    "SUBTITLE": "نظرة عامة على استراتيجيات المحفظة المتاحة",
    "STRATEGIES": {
      "CONSERVATIVE": {
        "NAME": "الحفاظ على رأس المال",
        "DESCRIPTION": "استراتيجية منخفضة المخاطر تركز على الحفاظ على رأس المال من خلال العملات المستقرة ذات العائد الثابت",
        "RISK_LEVEL": "مخاطر منخفضة"
      },
      "MODERATE": {
        "NAME": "التدفق النقدي",
        "DESCRIPTION": "استراتيجية منخفضة المخاطر تركز على الدخل الثابت من خلال العملات المستقرة والعملات المشفرة الرئيسية",
        "RISK_LEVEL": "مخاطر منخفضة"
      },
      "BALANCED": {
        "NAME": "متوازن",
        "DESCRIPTION": "استراتيجية متوازنة معتدلة المخاطر تشمل العملات المستقرة والعملات المشفرة الرئيسية والعملات البديلة المختارة",
        "RISK_LEVEL": "مخاطر معتدلة"
      },
      "AGGRESSIVE": {
        "NAME": "النمو",
        "DESCRIPTION": "استراتيجية عالية المخاطر تركز على العملات المشفرة الرئيسية والعملات البديلة الواعدة",
        "RISK_LEVEL": "مخاطر عالية"
      }
    },
    "ASSET_GROUPS": {
      "STABLECOINS": "العملات المستقرة",
      "BLUE_CHIPS": "العملات الرئيسية",
      "TOP_ALTCOINS": "أفضل العملات البديلة",
      "OTHER_ALTCOINS": "عملات بديلة أخرى",
      "INDICES": "المؤشرات"
    },
    "DETAILS": {
      "ASSETS": "الأصول",
      "YIELD_STRATEGY": "استراتيجية العائد",
      "APY_PROJECTION": "توقعات العائد السنوي"
    }
  },
  "ASSET_DETAIL_SCREEN": {
    "BACK": "رجوع",
    "PROJECT_NOT_FOUND": "المشروع غير موجود",
    "SETUP_STEPS": "خطوات الإعداد",
    "GO_TO_PROJECT": "الذهاب إلى المشروع",
    "STATS": {
      "APY": "العائد السنوي"
    },
    "STEPS": {
      "PREPARE_WEB3_WALLET": {
        "TITLE": "تجهيز محفظة Web3",
        "DESCRIPTION": "قم بتثبيت وإعداد محفظة Web3 تدعم الشبكة المختارة. على سبيل المثال، قم بتثبيت MetaMask لشبكات Ethereum، أو Phantom لـ Solana، أو Sui Wallet لشبكة Sui. تأكد من تكوين محفظتك بشكل صحيح وتأمينها."
      },
      "CONNECT_NETWORK": {
        "TITLE": "الاتصال بالشبكة",
        "DESCRIPTION": "أضف واتصل بالشبكة الصحيحة في محفظتك. إذا لم تتم إضافة الشبكة تلقائيًا، قد تحتاج إلى إضافتها يدويًا باستخدام عنوان RPC للشبكة، ومعرف السلسلة، وتفاصيل الشبكة الأخرى. تأكد من اتصالك بالشبكة الصحيحة قبل المتابعة."
      },
      "CHECK_GAS_BALANCE": {
        "TITLE": "التحقق من رصيد الرسوم",
        "DESCRIPTION": "تأكد من وجود رموز أصلية كافية في محفظتك لتغطية رسوم المعاملات. لشبكات Ethereum تحتاج إلى ETH، ولـ Solana - SOL، ولـ Sui - SUI. سيعتمد المبلغ الدقيق المطلوب على ازدحام الشبكة وتعقيد المعاملة."
      },
      "PREPARE_ASSETS": {
        "TITLE": "تجهيز الأصول",
        "DESCRIPTION": "قم بتحويل أو شراء الرموز المحددة التي تريد استثمارها (مثل USDC أو USDT أو DAI) إلى محفظتك المتصلة. تأكد من وجود الرموز في الشبكة الصحيحة - بعض الرموز موجودة في شبكات متعددة ولكن لا يمكن تحويلها مباشرة بينها."
      }
    }
  },
  "ERROR_SCREEN": {
    "TITLE": "عذراً! حدث خطأ ما",
    "DEFAULT_MESSAGE": "حدث خطأ. يرجى المحاولة مرة أخرى لاحقاً.",
    "RETRY_BUTTON": "حاول مرة أخرى",
    "SPECIFIC_ERRORS": {
      "DOCKER": "الخدمة غير متوفرة مؤقتاً. يرجى المحاولة مرة أخرى بعد بضع دقائق.",
      "NETWORK": "مشكلة في الاتصال بالشبكة. يرجى التحقق من اتصال الإنترنت الخاص بك.",
      "SERVICE": "الخدمة غير متوفرة مؤقتاً. فريقنا يعمل على حل المشكلة.",
      "DATABASE": "مشكلة في الوصول إلى قاعدة البيانات. يرجى المحاولة مرة أخرى لاحقاً."
    }
  }
}; 